<app-header *ngIf="siteSettings?.headerSettings" [navigation]="topNavigation" [settings]="siteSettings?.headerSettings"></app-header>

<app-scroll-top></app-scroll-top>

<app-main><router-outlet></router-outlet></app-main>

<app-footer *ngIf="siteSettings?.footerSettings && footer" [settings]="siteSettings.footerSettings" [data]="footer"></app-footer>
